import React from 'react';
import { Card, Typography } from 'antd';
import { useLocation } from 'react-router-dom';
import './CommonPage.less';

const { Title, Paragraph } = Typography;

interface CommonPageProps {
  title: string;
  description?: string;
}

const CommonPage: React.FC<CommonPageProps> = ({ title, description }) => {
  const location = useLocation();
  
  return (
    <div className="common-page">
      <Title level={2}>{title}</Title>
      <Card>
        <Paragraph>
          {description || `这是${title}页面，当前路径：${location.pathname}`}
        </Paragraph>
        <Paragraph>
          页面内容正在建设中，敬请期待...
        </Paragraph>
      </Card>
    </div>
  );
};

export default CommonPage;